module.exports = __webpack_public_path__ + "img/corporate-competition-2024-schedule-men-finals-1.87e14625.png";